
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router,  } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { environment } from "src/environments/environment";
import { CanonicalService } from "../services/canonical.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";
import { Utils } from "../utils/utils";
import { of } from "rxjs";

@Injectable({
    providedIn: 'root',
  })
  export class DividendYearResolver implements Resolve<Object| null> {
    constructor(
      private canonicalService: CanonicalService,
      @Inject(LOCALE_ID) private localId: Object,
      private seoService:MetaSeoService,
      public jsonldService: JsonldService,
      private router: Router,
    ){}

    resolve(route: ActivatedRouteSnapshot): Observable<Object| null> {
      const lang = (this.localId && (this.localId + "").substring(0, 2)) || 'tr';
      const yearParam = route.paramMap.get('year');
      const monthParam = route.paramMap.get('month');
      const currentYear = new Date().getFullYear();
      let year = parseInt(yearParam || '', 10);
      let month=Utils.checkMonthParam(monthParam,lang);
      let subSuffex="/dividend/year/"+year+"/"+month;

      if (isNaN(year) || year < 2000 || year > currentYear || monthParam != month) {
        year = 2024;
        subSuffex="/dividend/year/"+year+"/"+month;
        this.router.navigate([subSuffex]);
        return of(null); 
      }
      const domain=environment.domain;
      
      let canonicalURL = domain+"/"+lang+subSuffex;
      let domainAndLangURL=domain+"/"+lang;
      let prefixTitle=Utils.checkMonthParamString(month,lang)+year;
      let title=prefixTitle+" Temettü Hisseleri  | Halka Arz";
      let noIndex;      
      let description=prefixTitle+' yılı Temettü veren hisseler, '+prefixTitle+' Temettü Takvimi ve '+prefixTitle+' yılında Temettü Veren Hisselerin Tam Listesi';
      if(lang.substring(0,2)=="tr"){
        title=prefixTitle+" Temettü Hisseleri | Halka Arz";
        prefixTitle+' yılı Temettü veren hisseler, '+prefixTitle+' Temettü Takvimi, '+prefixTitle+' yılında Temettü Veren Hisselerin Tam Listesi';
      }
      this.canonicalService.setCanonicalURLForId(canonicalURL);
      this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,noIndex);
      this.canonicalService.setWrapperAlternate(domain,subSuffex);
      this.jsonldService.setOrganization();
      this.jsonldService.setBreadCrumbListItem(domain,lang,subSuffex,title);
      this.jsonldService.setWebSiteType(domain,lang);
      this.jsonldService.setTableType(prefixTitle+" Temettü Hisseleri");
      return of(null); 
    }
  
}
